<template>
    <form ref="form">
        <div class="d-flex align-items-center mb-3">
            <div class="mr-auto mb-0">
                <h3 class="text-3 font-weight-bold mb-1">Buy Insurance & Licence</h3>
                <h6 class=" text-1 font-weight-bold">{{ stage }}/4 - {{ stageName[stage] }}</h6>
            </div>
            <button v-if="customer && success" @click="showUserDetails = !showUserDetails" type="button"
                    class="btn btn-outline-primary py-1 px-4 shadow-none">
                <template v-if="!showUserDetails">
                    <svg class="svg-icon mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"/>
                    </svg>
                    {{ customer.firstName }}
                </template>
                <small v-else><i  class="fa fa-times"></i> Hide info</small>
            </button>
        </div>


        <transition name="fade">
            <div v-if="showUserDetails && customer && success" class="bg-primary rounded text-white px-3 py-3 my-3">
                Name : <strong>{{ customer.firstName }}</strong> <br>
                Last Name : <strong>{{ customer.surname }}</strong> <br>
                National ID : <strong>{{ customer.nationalId }}</strong> <br>
                Phone : <strong>{{ customer.msisdn }}</strong> <br>
            </div>
        </transition>

        <div v-if="!success && message" class="bg-primary text-white px-3 py-3 my-3">
            {{ message }}
        </div>


        <transition-group v-if="success" name="slide-in-left">
            <div key="1" v-if="stage === 1">
                <div class="form-group">
                    <label>Which Vehicle?</label>
                    <select :class="[ 'custom-select' , form.errors.get('vehicle') ? 'is-invalid' : '' ]"
                            v-model="form.vehicle"
                            @change="form.errors.clear('vehicle')"
                    >
                        <option value="">Choose Vehicle</option>
                        <option v-for="item in vehicles" :value="item.vrn">{{ item.vrn }}</option>
                    </select>
                    <div v-text="form.errors.get('vehicle')" class="text-danger"/>
                    <p>
                        <router-link :to="`/zinara/vehicles/create?id=${this.$route.query.id}`">
                            <strong>Manage</strong>
                        </router-link>
                        <span>your vehicles or </span>
                        <router-link :to="`/zinara/vehicles/create?id=${this.$route.query.id}`">
                            <strong>Add vehicle</strong>
                        </router-link>
                    </p>
                </div>
                <div class="form-group">
                    <label>What are you purchasing?</label>
                    <select :class="[ 'custom-select' , form.errors.get('purchase') ? 'is-invalid' : '' ]"
                            v-model="form.purchase">
                        <option value="">Choose Purchase</option>
                        <!--<option value="Insurance">Insurance</option>-->
                        <!--<option value="Zinara & Insurance">Insurance & ZINARA</option>-->
                        <option value="Zinara & Insurance & Radio">Insurance & ZINARA & Radio</option>
                    </select>
                    <div v-text="form.errors.get('purchase')" class="text-danger"/>
                </div>
                <div class="form-group">
                    <label @click.prevent="showInsuranceHelp = !showInsuranceHelp">
                        <span>Which type of Insurance?</span>
                        <!--<small v-if="form.insurance"><i  class="fa fa-times"></i> Hide description</small>-->
                    </label>

                    <select :class="[ 'custom-select' , form.errors.get('insurance') ? 'is-invalid' : '' ]"
                            v-model="form.insurance"
                            @change="showInsuranceHelp = !!form.insurance">
                        <option value="">Choose Insurance</option>
                        <option :value="insurance" v-for="insurance in Object.keys(descriptions)">
                            {{ descriptions[insurance].name }}
                        </option>
                    </select>
                    <div v-text="form.errors.get('insurance')" class="text-danger"/>
                    <p v-if="showInsuranceHelp && form.insurance" class="alert alert-info mb-3 mt-2">
                        <span  v-if="descriptions[form.insurance].plus">
                              <a class="badge badge-success text-white">{{ descriptions[form.insurance].plus }}</a>
                            <br/>
                        </span>
                        <strong>{{ descriptions[form.insurance].name }}: </strong>
                        {{ descriptions[form.insurance].description }}.
                        Ts & Cs apply. More information available on <a href="https://www.moovah.co.zw/packages"
                                                                      target="_blank">moovah.co.zw</a>
                    </p>

                </div>
                <div class="form-group">
                    <label>Vehicle Value [ZWG]</label>
                    <input type="text" class="form-control" v-model="form.value" @input="formatField"/>
                    <div v-text="form.errors.get('value')" class="text-danger"/>
                </div>
                <div class="form-group">
                    <label>Period</label>
                    <select :class="[ 'custom-select' , form.errors.get('period') ? 'is-invalid' : '' ]"
                            v-model="form.period">
                        <option value="">Choose Period</option>
                        <option value="4">4 Months (1 term)</option>
                        <!--<option value="8">8 Months (2 terms)</option>
                        <option value="12">12 Months (3 terms)</option>-->
                    </select>
                    <div v-text="form.errors.get('period')" class="text-danger"/>
                </div>
                <button type="button" class="btn btn-block btn-primary px-4" @click.prevent="stage++" :disabled="!validateStageOne()" :class="{ 'bg-dark-5': !validateStageOne() }">
                    Next
                </button>
            </div>
            <div key="2" v-if="stage === 2">
                <div class="form-group">
                    <label>Delivery Method</label>
                    <select :class="[ 'custom-select' , form.errors.get('delivery') ? 'is-invalid' : '' ]"
                            v-model="form.delivery">
                        <option value="">Choose Delivery Method</option>
                        <option value="DELIVERY">Delivery</option>
                        <option value="COLLECT">Collect</option>
                    </select>
                    <div v-text="form.errors.get('delivery')" class="text-danger"/>
                </div>
                <div v-if="form.delivery" class="border bg-light-1 rounded-lg p-3 mb-3">
                    <template v-if="form.delivery === 'COLLECT'">
                        <small>Collection Address</small>
                        <p>5th Floor, Eastgate, Cnr 2nd Ave/R.G Mugabe St, Harare</p>
                    </template>
                    <template v-if="form.delivery === 'DELIVERY'">
                        <div class="form-group">
                            <label>Delivery Address</label>
                            <small>House Number & Street</small>
                            <input type="text" class="form-control" v-model="form.delivery_house"/>
                            <div v-text="form.errors.get('delivery_house')" class="text-danger"/>
                        </div>
                        <div class="form-group">
                            <label>Delivery Address</label>
                            <small>Suburb</small>
                            <input type="text" class="form-control" v-model="form.delivery_street"/>
                            <div v-text="form.errors.get('delivery_street')" class="text-danger"/>
                        </div>
                        <div class="form-group mb-0">
                            <label>Delivery Address</label>
                            <small>City</small>
                            <select class="form-control mt-2" v-model="form.delivery_city">
                                <option value="">Select a city</option>
                                <option v-for="city in sortedCities" :value="city">{{ city }}</option>
                            </select>
                            <div v-text="form.errors.get('delivery_city')" class="text-danger"></div>
                        </div>
                    </template>
                </div>
                <div class="form-group">
                    <label>Payment Method [{{ methods[form.payment] }}]</label>
                    <select :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]"
                            v-model="form.payment">
                        <option value="">Choose Payment Method</option>
                        <option value="ecocash">EcoCash</option>
                        <!--                                        <option value="stripe">International Card</option>-->
                    </select>
                    <div v-text="form.errors.get('payment')" class="text-danger"/>
                </div>

                <div v-if="form.payment === 'ecocash'" class="form-group">
                    <label for="ecocash" class="form-label">EcoCash Phone Number</label>
                    <phone-input id="ecocash" required="" aria-describedby="ecocash"
                                 v-model="form.ecocash" :countries="['ZW']"
                                 placeholder="Enter EcoCash Phone Number"></phone-input>
                    <div v-text="form.errors.get('ecocash')" class="text-danger"/>
                </div>
                <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="form.email"/>
                    <div v-text="form.errors.get('email')" class="text-danger"/>
                </div>
                <div class="form-group">
                    <label>Promo Code</label>
                    <input type="text" class="form-control" v-model="form.promo_code"/>
                    <div v-text="form.errors.get('promo_code')" class="text-danger"/>
                </div>
                <button type="button" class="btn btn-block btn-primary px-4 mb-3" @click.prevent="stage++" :disabled="!validateStageTwo()" :class="{ 'bg-dark-5': !validateStageTwo() }">
                    Next
                </button>
                <button type="button" class="btn btn-block btn-outline-primary px-4" @click.prevent="stage--">
                    Previous
                </button>
            </div>
            <div key="3" v-if="stage === 3">
                <div v-if="form.errors.get('vehicle')" v-text="form.errors.get('vehicle')" class="alert alert-danger"/>
                <div v-if="form.errors.get('phone')" v-text="form.errors.get('phone')" class="alert alert-danger"/>

                <div>
                    <div class="p-2"><strong>Vehicle:</strong><br> {{ form.vehicle }}</div>
                    <div class="p-2"><strong>Value:</strong><br>ZWG {{ formatNumber(form.value) }}</div>
                    <div  class="p-2"><strong>Cover:</strong><br> {{ descriptions[form.insurance].name }}</div>
                    <div  class="p-2"><strong>Purchase:</strong><br> {{ form.purchase }}</div>
                    <div  class="p-2"><strong>Period:</strong><br> {{ form.period }} Months</div>
                    <hr/>
                    <div  class="p-2" v-if="form.delivery === 'DELIVERY'"><strong>Delivery To:</strong><br> {{ form.delivery_house }}, {{ form.delivery_street }}, {{ form.delivery_city }}</div>
                    <div  class="p-2" v-if="form.delivery === 'COLLECT'"><strong> To Collect From:</strong><br>5th Floor,Blue Bridge, Eastgate, Cnr 2nd Ave/R.G Mugabe St, Harare<br>Contact +263 785 832 033 </div>
                    <div  class="p-2 mb-2 text-capitalize" ><strong>Paying with:</strong><br> EcoCash</div>
                    <hr/>
                </div>
                <button type="button"
                        :class="['btn btn-block btn-primary px-4 mb-3' , form.loading || loading ? 'btn-loading' : '']"
                        @click="summary">
                    Get Quote
                </button>
                <button type="button" class="btn btn-block btn-outline-primary px-4" @click.prevent="stage--" >
                    Previous
                </button>
            </div>
            <div key="4" v-if="stage === 4">
                <div>
                    <!--<div class="p-2"><strong>Status :</strong><br> {{ invoice.status }}</div>-->
                    <!--<div class="p-2"><strong>Request Channel :</strong><br>{{ invoice.requestChannel }}</div>-->
                    <div class="p-2"><strong>Vehicle Value :</strong><br>ZWG {{ formattedVehicleValue }} </div>
                    <div  class="p-2"><strong>Cover:</strong><br> {{ descriptions[form.insurance].name }}</div>
                    <div class="p-2"><strong>Description :</strong><br> {{ invoice.invoiceLines[0].description }}</div>
                    <div v-if="invoice.invoiceLines[0].radioPeriod > 0" class="p-2"><strong>Add-ons :</strong><br> Radio Licence</div>
                    <div class="p-2"><strong>Amount Due :</strong><br> <h4 style="color: #4c4d4d">ZWG {{ formattedInvoiceAmount }}</h4> </div>
                    <hr/>
                    <div class="row">
                      <div class="col-6">
                          <div class="p-2"><strong>Payment Method : </strong><br>  {{ form.payment === 'ecocash' ? "EcoCash" : "International Card" }}</div>
                      </div>
                        <div class="col-6">
                            <div v-if="form.payment === 'ecocash'">
                                <div class="p-2"><strong>EcoCash Number :</strong><br>{{ form.ecocash }} </div>
                            </div>
                            <div v-else>
                                <div class="p-2"><strong>Email : </strong><br>{{ form.email }} </div>
                            </div>
                        </div>
                    </div>

                    <hr/>
                </div>
                <div class="text-center mt-3">
                    <button type="button"
                            :class="['btn btn-danger px-4 py-1' , form.loading || loading ? 'btn-loading' : '']"
                            @click="cancelAndClear">
                        Cancel Transaction
                    </button>

                    <button type="button"
                            :class="['btn btn-primary px-4 py-1' , form.loading || loading ? 'btn-loading' : '']"
                            @click="payment">
                        Pay
                    </button>

                </div>
                <button type="button"
                        :class="['btn btn-block btn-primary px-4 mt-2' , form.loading || loading ? 'btn-loading' : '']"
                        @click="summary">
                    Get Summary
                </button>
                <button type="button" class="btn btn-block btn-outline-primary px-4 mt-2" @click.prevent="cancel" >
                    Change Information
                </button>
            </div>
        </transition-group>

        <div v-if="!success">
            <router-link v-if="!success" to="/zinara"
                         :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']">
                Close
            </router-link>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";
import { formatValue, removeCommas } from '../../../core/utils/numbers';
import {appDataMixin} from "../../../core/data/global";

export default {
    name: "dashboard",
    components: {PhoneInput},
    mixins: [validity, appDataMixin],
    data: function () {
        return {
            loading: false,
            showUserDetails: true,
            showInsuranceHelp: true,
            stage: 1,
            stageName: {
                1: 'Vehicle & Insurance',
                2: 'Payment & Delivery',
                3: 'Summary',
                4: 'Confirmation & Payment'
            },
            success: false,
            showSummary: false,
            fields: [],
            message: null,
            errorMessage: '',
            formattedVehicleValue:'',
            formattedInvoiceAmount:'',
            customer: null,
            vehicles: [],
            invoice: {},
            methods: {
                'ecocash': 'ZWG',
                'stripe': 'USD',
            },
            form: new Form({
                id: this.$route.query.id,
                phone: '',
                vehicle: '',
                purchase: '',
                insurance: '',
                period: '',
                delivery: '',
                promo_code:'',
                payment: 'ecocash',
                value: '',
                ecocash: '',
                email: '',
                invoice: '',
                delivery_house: '',
                delivery_street: '',
                delivery_city: '',
            }),
            descriptions: {
                1: {
                    name: 'Third Party (RTA)',
                    description: 'Third Party (Road Traffic Act) Covers liability for death or bodily injury to third party vehicles or third-party property.\n' +
                        'Third-party bodily injury and death is covered up to $3,000 and third-party property damage up to $2,000',
                    plus: 'Popular Third Party Product'
                }
               /* 2: {
                    name: 'Full Third Party',
                    description: 'Third-party bodily injury and death is covered up to $10,000 and third-party property damage up to $10,000'
                },
                3: {
                    name: 'Full Third Party, Fire & Theft',
                    description: 'Covers damage or loss caused by fire or theft or attempted theft to the insured vehicle or its accessories.\n' +
                        'Third-party bodily injury and death is covered up to $10,000 and third-party property damage up to $10,000'
                },
                4: {
                    name: 'Comprehensive Cover',
                    description: 'Cover is provided for accidental damage to the insured vehicle, third-party property and bodily injury up to $20,000.\n' +
                        'The insured vehicle is covered up to the insured value or market value.\n' +
                        'Covers your car if it\'s damaged by hail, storms, falling tree or other acts of nature or through accident.24hours roadside assistance countrywide, 365 days in the event of an accident from AAZ (0712 406 033, 0782 783 691, 04-2932089).\n' +
                        'Tow the vehicle to the nearest Econet Insurance inspection site/storage yard'
                },*/
            },
            cities: [
                "Harare",
                "Bulawayo",
                "Chitungwiza",
                "Mutare",
                "Epworth",
                "Gweru",
                "Kwekwe",
                "Kadoma",
                "Masvingo",
                "Chinhoyi",
                "Norton",
                "Marondera",
                "Ruwa",
                "Chegutu",
                "Zvishavane",
                "Bindura",
                "Beitbridge",
                "Redcliff",
                "Victoria Falls",
                "Hwange",
                "Rusape",
                "Chiredzi",
                "Kariba",
                "Karoi",
                "Chipinge",
                "Gokwe",
                "Shurugwi"
            ]
        };
    },

    methods: {

        formatField() {
            this.form.value = formatValue(this.form.value);
        },

        formatNumber(value) {
            return formatValue(value);
        },

        fetchListOfVehicles() {
            this.loading = true;
            this.form.submit('/zinara/vehicles/list').then((response) => {
                this.loading = false;
                this.form.phone = response.data.body.phone;
                this.vehicles = response.data.body.vehicles;
                this.customer = response.data.body.customer;

                this.success = response.data.success;
                this.message = response.data.message;
            });
        },

        payment() {
            this.loading = true;
            this.form.value = removeCommas(this.form.value);
            this.form.submit('/zinara/init').then((response) => {

                // Redirect based on payment type
                if (response.data.success) {
                    if (response.data.body.payment.payment === "ecocash") {
                        this.$router.push(`/zinara/ecocash?id=${response.data.body.payment.ref}`);
                    }

                    if (response.data.body.payment.payment === "stripe") {
                        window.location.href = response.data.body.payment.url;
                    }

                } else {

                }
            });
        },

        clearForm() {
            this.form = {
                value: '',
                vehicle: '',
                insurance: '',
                purchase: '',
                period: '',
                delivery: '',
                delivery_house: '',
                delivery_street: '',
                delivery_city: '',
                payment: '',
                ecocash: '',
                email: '',
            };
        },
        cancel() {
            this.loading = true;
            this.form.value = removeCommas(this.form.value);
            this.form.submit('/zinara/invoice/cancel').then((response) => {
                this.loading = false;
                this.showSummary = false;
                this.stage = 1;
            });
        },
        cancelAndClear() {
            this.cancel().then(() => {
                this.clearForm();
            });
        },

        async summary() {
            this.form.value = removeCommas(this.form.value);
            await this.form.submit('/zinara/summary').then((response) => {
                this.loading = false;
                this.invoice = response.data.body.invoice;
                this.formattedInvoiceAmount = this.invoice.amount.toLocaleString();
                this.formattedVehicleValue = this.formatNumber(this.invoice.invoiceLines[0].vehicleValue);
                this.form.invoice = this.invoice;
                this.stage = 4;
            })
        },

        validateStageOne() {
            return this.form.vehicle && this.form.purchase && this.form.insurance && this.form.period;
        },
        validateStageTwo() {
            if (this.form.delivery === 'COLLECT') {
                return this.form.delivery && this.form.payment && this.form.email;
            } else if (this.form.delivery === 'DELIVERY') {
                return this.form.delivery_house && this.form.delivery_street && this.form.delivery_city && this.form.payment && this.form.email;
            } else {
                return false;
            }
        },
        validateStageThree() {
            return true;
        }
    },

    watch: {
        stage() {
            window.scrollTo({
                    top: 280,
                behavior: 'smooth'
            });
        },
    },

    mounted() {
        this.fetchListOfVehicles();
    },
    computed: {
        sortedCities: function() {
            return this.cities.slice().sort();
        }
    }
}
</script>

<style scoped>

</style>
